import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const GymCard = ({ gym, onEdit, onToggleStatus }) => {
  return (
    <div className="card hover:shadow-lg transition-shadow duration-250">
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <h3 className="text-lg font-heading font-semibold text-foreground">
              {gym?.name}
            </h3>
            <div
              className={`w-2 h-2 rounded-full ${
                gym?.is_active ? 'bg-success' : 'bg-error'
              }`}
              title={gym?.is_active ? 'Active' : 'Inactive'}
            />
          </div>
          <p className="text-sm text-muted-foreground">
            {gym?.memberCount || 0} members
          </p>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onEdit(gym)}
        >
          <Icon name="Edit" size={16} />
        </Button>
      </div>

      {/* Location Info */}
      <div className="space-y-2 mb-4">
        <div className="flex items-start gap-2">
          <Icon name="MapPin" size={16} className="text-muted-foreground mt-0.5 flex-shrink-0" />
          <div className="text-sm text-foreground">
            <p>{gym?.address}</p>
            <p>{gym?.city}, {gym?.state} {gym?.zip_code}</p>
          </div>
        </div>

        {gym?.phone && (
          <div className="flex items-center gap-2">
            <Icon name="Phone" size={16} className="text-muted-foreground flex-shrink-0" />
            <p className="text-sm text-foreground">{gym?.phone}</p>
          </div>
        )}

        {gym?.email && (
          <div className="flex items-center gap-2">
            <Icon name="Mail" size={16} className="text-muted-foreground flex-shrink-0" />
            <p className="text-sm text-foreground">{gym?.email}</p>
          </div>
        )}
      </div>

      {/* Actions */}
      <div className="pt-4 border-t border-border flex items-center gap-2">
        <Button
          variant={gym?.is_active ? 'warning' : 'success'}
          size="sm"
          className="flex-1"
          onClick={() => onToggleStatus(gym?.id, gym?.is_active)}
        >
          <Icon 
            name={gym?.is_active ? 'XCircle' : 'CheckCircle'} 
            size={16} 
            className="mr-2" 
          />
          {gym?.is_active ? 'Deactivate' : 'Activate'}
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="flex-1"
          onClick={() => onEdit(gym)}
        >
          <Icon name="Settings" size={16} className="mr-2" />
          Manage
        </Button>
      </div>
    </div>
  );
};

export default GymCard;
